/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Alloc_ColInputs */

const vi_customer_debt_payment_alloc_col = /** @type {(inputs: Customer_Debt_Payment_Alloc_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bổ`)
};

/**

* @param {Customer_Debt_Payment_Alloc_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_alloc_col = /** @type {((inputs?: Customer_Debt_Payment_Alloc_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Alloc_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_alloc_col(inputs)
});